module.exports = __webpack_public_path__ + "img/mobile.1a2796b4.svg";